import Vue from 'vue';

const state = Vue.observable({
  adminType: localStorage.getItem("adminType")
});

export function setLocalStorage(key, value) {
  // localStorage.setItem(key, value);
  state[key] = value;
}

export function getLocalStorage(key) {
  return state[key];
}

window.addEventListener('storage', (e) => {
  console.log('change...111');
  if (e.key && state.hasOwnProperty(e.key)) {
    Vue.set(state, e.key, e.newValue); // 响应式更新
  }
});

export default state;